import { getShareClassName } from "@/lib";
import type { ShareClass } from "@/types";
import CTA from "../CTA";
import DropdownSelect from "../DropdownSelect";
import * as styles from "./ShareClassSelector.css";
import type { Props } from "./types";

export default function ShareClassSelector({
	shareClasses,
	value,
	onChange,
	label = shareClasses.length === 1 ? "Share class" : "Select share class",
	className,
	sameWidth = true,
}: Props) {
	const findShareClass = (id: string) =>
		shareClasses.find((sc) => `${sc.id}` === id);
	return shareClasses.length === 1 ? (
		<ShareClassButton
			label={label}
			className={`${className} no-select`}
			name={shareClasses[0] ? getShareClassName(shareClasses[0]) : ""}
		/>
	) : (
		<DropdownSelect
			value={`${value}`}
			options={shareClasses.map((sc) => ({
				value: `${sc.id}`,
			}))}
			renderValue={renderShareClassValue.bind(null, findShareClass)}
			renderItem={renderShareClassItem.bind(null, findShareClass)}
			onChange={(id) => onChange?.(Number.parseInt(id))}
			className={className}
			sameWidth={sameWidth}
		>
			{label.length > 0 && (
				<span className={styles.shareClassLabel}>{label}</span>
			)}
		</DropdownSelect>
	);
}

const renderShareClassValue = (
	finder: (id: string) => ShareClass | undefined,
	id: string,
) => {
	const shareclass = finder(id);
	if (!shareclass) return <>Not found</>;
	return (
		<div className={styles.shareClassValue}>
			{getShareClassName(shareclass)}
		</div>
	);
};

const renderShareClassItem = (
	finder: (id: string) => ShareClass | undefined,
	id: string,
) => {
	const shareclass = finder(id);
	if (!shareclass) return <>Not found</>;
	return (
		<div className={styles.shareClassItem}>
			<div>{getShareClassName(shareclass)}</div>
			<div className={styles.shareClassIsin}>{shareclass.isin}</div>
		</div>
	);
};

const ShareClassButton = ({
	name,
	label,
	className,
}: { name: string; label: string; className?: string }) => {
	return (
		<div className={`${styles.shareClassValue} ${className}`}>
			{label.length > 0 && (
				<div className={styles.shareClassLabel}>{label}</div>
			)}
			<CTA
				size="l"
				badge
				className={styles.shareClassSelect}
				label="left"
				animated={false}
			>
				{name}
			</CTA>
		</div>
	);
};
